import { BillableItemAssociation, MixDesignIngredientType, MixDesignIngredientTypes, ModelObject } from '@cco/model';

export interface MixDesignIngredient extends ModelObject<number> {
  id: number;
  typeId: number;
  type?: MixDesignIngredientType;
  name: string;
  density: number;
  densityUnitId: number;
  cementitious: boolean;
  billableItemAssociations: BillableItemAssociation[];
}

export const mixDesignIngredientComparer = (a: MixDesignIngredient, b: MixDesignIngredient) => {
  // console.log(a);
  return MixDesignIngredientTypes.sortOrder.indexOf(a.typeId) > MixDesignIngredientTypes.sortOrder.indexOf(b.typeId) ? 1 : -1;
};
